module.exports = __webpack_public_path__ + "img/suzhou.0a19396a.png";